import { useEffect } from 'react';

const SITE_NAME = 'GetBenefitSavings';

const PAGE_TITLES = {
  home: 'Maximize Your Credit Card Benefits & Employee Perks',
  articles: 'Benefits Knowledge Center',
  contact: 'Contact Us',
  about: 'About Us',
  privacy: 'Privacy Policy',
  terms: 'Terms of Service',
  getstarted: 'Get Started',
  calculator: 'Benefits Calculator',
};

export function usePageTitle(pageTitle) {
  useEffect(() => {
    const previousTitle = document.title;

    if (pageTitle) {
      document.title = `${pageTitle} | ${SITE_NAME}`;
    } else {
      document.title = `${SITE_NAME} - ${PAGE_TITLES.home}`;
    }

    return () => {
      document.title = previousTitle;
    };
  }, [pageTitle]);
}

export { PAGE_TITLES };
export default usePageTitle;
